/* eslint-disable import/prefer-default-export */

export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE'
